import type { PapelUsuario } from '@pgcustom/shared-types';

export interface PermissoesEstoque {
  ler: boolean;
  criar: boolean;
  atualizar: boolean;
}

/**
 * Espelho, no frontend, do grant real de RBAC do recurso `estoque`
 * (`apps/api/src/modules/estoque/estoque.routes.ts`, seed original da
 * migration `004`): `admin` (curinga `*`) tem tudo; `producao` só
 * `ler` ("leitura de estoque", seed original). Nenhum papel dedicado a
 * "Estoque" existe em `PRODUCT.md` — gestão é responsabilidade
 * administrativa. Usado apenas para decidir o que mostrar na UI — a
 * autorização real é sempre revalidada pelo backend.
 */
export function permissoesEstoque(papel: PapelUsuario): PermissoesEstoque {
  if (papel === 'admin') return { ler: true, criar: true, atualizar: true };
  if (papel === 'producao') return { ler: true, criar: false, atualizar: false };
  return { ler: false, criar: false, atualizar: false };
}
